import {
  CAT_RUNNING_BACKGROUND_SCROLL_RATIO,
  CAT_RUNNING_CROW_FRAME_MS,
  CAT_RUNNING_OBSTACLE_DESPAWN_MARGIN,
} from '../../constants'
import { updateGroundObstacleSpawner } from '../spawners/obstacles'

export const updateBackgroundScroll = (world, deltaSec) => {
  world.previousBackgroundOffset = world.backgroundOffset
  world.backgroundOffset =
    (world.backgroundOffset + world.speed * CAT_RUNNING_BACKGROUND_SCROLL_RATIO * deltaSec) % 100000
}

export const updateObstaclePositions = (world, deltaSec) => {
  world.obstacles.forEach((obstacle) => {
    obstacle.previousX = obstacle.x
    obstacle.x -= world.speed * deltaSec

    if (obstacle.kind === 'crow') {
      obstacle.frameIndex = Math.floor(world.elapsedMs / CAT_RUNNING_CROW_FRAME_MS) % 2
    }
  })
}

export const cleanupObstacles = (world) => {
  world.obstacles = world.obstacles.filter(
    (obstacle) => obstacle.x + obstacle.width >= -CAT_RUNNING_OBSTACLE_DESPAWN_MARGIN,
  )
}

export const updateObstacles = (world, deltaSec, warmupDistance) => {
  updateObstaclePositions(world, deltaSec)
  cleanupObstacles(world)
  updateGroundObstacleSpawner(world, deltaSec, warmupDistance)
}
